// Mouse-look state and the camera direction it produces. Pure: tests cover
// the clamp and the direction math.

export interface LookState {
  /** Yaw in radians around +Y. 0 = looking toward -Z. */
  readonly yaw: number;
  /** Pitch in radians; positive looks up. Clamped short of ±90°. */
  readonly pitch: number;
}

export const PITCH_LIMIT = Math.PI / 2 - 0.05;

export function applyLook(
  state: LookState,
  dx: number,
  dy: number,
  sensitivity: number,
): LookState {
  const yaw = state.yaw - dx * sensitivity;
  const pitch = Math.max(-PITCH_LIMIT, Math.min(PITCH_LIMIT, state.pitch - dy * sensitivity));
  return { yaw, pitch };
}

/** The unit forward vector for a look state (three.js: -Z is forward). */
export function lookDirection(state: LookState): [number, number, number] {
  const cp = Math.cos(state.pitch);
  return [-Math.sin(state.yaw) * cp, Math.sin(state.pitch), -Math.cos(state.yaw) * cp];
}
